/**
 * Copyright 2021 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { Section } from '@umati/dashboard-types';
import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import TemplateHelper from '../../../utilities/TemplateHelper';
import SectionRowContent from './SectionRowContent';

export interface SectionCardProps {
  eventKey: string;
  title: string;
  section: Section;
  data: any;
  isExpanded?: boolean;
  sectionIndex: number;
  sectionDataIndex: number;
}

export interface SectionCardState {
  expanded: boolean;
}

export default class SectionCard extends Component<SectionCardProps, SectionCardState> {
  constructor (props : SectionCardProps) {
    super(props);
    this.state = {
      expanded: !!props.isExpanded
    };
  }

  render () {
    const colStyle = 'col-4 col-sm-4 col-md-4';

    return (
      <Card className="mb-4">
        <Card.Header>
          <h3 className="h5 mb-0">{this.props.title}</h3>
        </Card.Header>
        <Card.Body>
          {this.props.section.rows.map((row, rowIndex) => (
          <>
          {!row.isPlaceholder &&
            <SectionRowContent key={TemplateHelper.getKeyRow(this.props.sectionIndex, this.props.sectionDataIndex, rowIndex)}
              row={row} cols={colStyle} data={this.props.data}
              sectionIndex={this.props.sectionIndex} sectionDataIndex={this.props.sectionDataIndex}
              rowIndex={rowIndex} rowDataIndex={0}
              title={row.title} />
          }
          {row.isPlaceholder &&
          <>
            {TemplateHelper.getPlaceholderObjects(this.props.data, row.placeholderObject, row.placeholderConditionType).map((innerData, innerDataIndex) => (
            <SectionRowContent key={TemplateHelper.getKeyRow(this.props.sectionIndex, this.props.sectionDataIndex, rowIndex, innerDataIndex)}
              row={row} cols={colStyle} data={innerData}
              sectionIndex={this.props.sectionIndex} sectionDataIndex={this.props.sectionDataIndex}
              rowIndex={rowIndex} rowDataIndex={innerDataIndex}
              title={row.titleVariable ? TemplateHelper.getVariableValue(innerData, row.titleVariable) : undefined} />
            ))}
            </>
          }
          </>
          ))}
        </Card.Body>
      </Card>
    );
  }
}
